<template>
<sui-page>
  <sui-page-header :title="pageTitle" :location-list="pageLocations" :is-favorites="isMyFavorites"></sui-page-header>
  <sui-page-contents>    
      <sui-lnb-tree v-bind="fdpTree00" style="overflow-y:auto; width: 400px;"></sui-lnb-tree>
  </sui-page-contents>
</sui-page>
</template>

<script>
  export default {
    name: "TMP_COM_002",
    data() {
      return {
        isMultiSelect: true,
        showCheckbox: true,
        fdpTree00: {
          data: [{
            text: 'G-EHS',
            opened: true,
            children: [{
              text: 'Tree01 depth_1',
              id: 'btn01',
              opened: true,
              children: [{
                text: 'Tree01 depth_2',
                opened:true,
                children:[
                  {text:'Tree01 depth_30',
                  id: 'item30',
                   opened: true,
                   children: [{text:'Tree01 depth_40', selectable: true},{text:'Tree01 depth_41', selectable: false}]
                },
                  {text:'Tree01 depth_31'},{text:'Tree01 depth_32'},{text:'Tree01 depth_33'},{text:'Tree01 depth_34'}]

              }, {
                text: 'Tree01 depth_2'
              }]
            }, {
              text: 'Tree02 depth_1'
            },
            {
              text: 'Tree03 depth_1'
            },
            {
              text: 'Tree04 depth_1',
              opened:true,
              children: [{text:'Tree04 depth_21'},{text:'Tree04 depth_22'},{text:'Tree04 depth_23'}]

            },
            {
              text: 'Tree05 depth_1'
            }]
          },{
            text: 'G-EHS',
            opened: true,
            children: [{
              text: 'Tree01 depth_1',            
              opened: true,
              children: [{
                text: 'Tree01 depth_2',
                opened:true,
                children:[]
              }, {
                text: 'Tree01 depth_2'
              }]
            }, {
              text: 'Tree02 depth_1'
            },
            {
              text: 'Tree03 depth_1'
            },
            {
              text: 'Tree04 depth_1',
              opened:true,
              children: [{text:'Tree04 depth_21'},{text:'Tree04 depth_22'},{text:'Tree04 depth_23'}]

            },
            {
              text: 'Tree05 depth_1'
            }]
          }]
        },
        localdata1: [
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4'],
          ['1', '2', '3', '4']
        ],
        gridColumns1: [{
          text: '컬럼01',
          datafield: 'datafield0'
        }, {
          text: '타이틀이겁나길면어떻게들어가나봅시다',
          datafield: 'datafield1'
        }, {
          text: '이만큼쓰면넘어가려나점이생기려나',
          datafield: 'datafield2'
        }, {
          text: '일하기싫을때는 집에가자 먹고싶을땐 대지같이 먹자',
          datafield: 'datafield3'
        }],
        localdata2: [
          ['1', '로또1등 2번이나 당첨된 사람', '취미로 회사다니는 사람', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['취미로 회사다니는 사람', '22', '33', '가진게돈밖에 없는 사람', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55'],
          ['1', '2', '3', '4', '5'],
          ['11', '22', '33', '44', '55']
        ],
        gridColumns2: [{
          text: '제목',
          datafield: 'datafield0'
        }, {
          text: '이름이길어지면 이게 맞는건가',
          datafield: 'datafield1'
        }, {
          text: '공백',
          datafield: 'datafield2'
        }, {
          text: '나도몰라',
          datafield: 'datafield3'
        }, {
          text: '오늘할일은내일로',
          datafield: 'datafield4'
        }]
      };
    },
    datasets: [{
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [{
        name: 'chk',
        type: 'string',
        map: '0'
      }, {
        name: 'datafield1',
        type: 'string',
        map: '1'
      }, {
        name: 'textfield',
        type: 'string',
        map: '2'
      }, {
        name: 'datafield2',
        type: 'string',
        map: '3'
      }, {
        name: 'datafield3',
        type: 'string',
        map: '4'
      }, {
        name: 'datafield4',
        type: 'string',
        map: '5'
      }]
    }, {
      id: 'dataset1',
      type: 'local',
      data: 'localdata1',
      datafields: [{
        name: 'datafield0',
        type: 'string',
        map: '0'
      }, {
        name: 'datafield1',
        type: 'string',
        map: '1'
      }, {
        name: 'datafield2',
        type: 'string',
        map: '2'
      }, {
        name: 'datafield3',
        type: 'string',
        map: '3'
      }]
    }, {
      id: 'dataset2',
      type: 'local',
      data: 'localdata2',
      datafields: [{
        name: 'datafield0',
        type: 'string',
        map: '0'
      }, {
        name: 'datafield1',
        type: 'string',
        map: '1'
      }, {
        name: 'datafield2',
        type: 'string',
        map: '2'
      }, {
        name: 'datafield3',
        type: 'string',
        map: '3'
      }, {
        name: 'datafield4',
        type: 'string',
        map: '4'
      }]
    }],
    mounted() {
      http.getGnbMenus().then(res => {
        console.log(res);
        http.getLnbMenu(res[0].applicationId).then(res => {
          console.log(res);
        });
      });
    },
    methods: {
      onClickSelect() {
        this.$refs.tree04.select('btn01');
        //this.$refs.tree04.select(1);
        //this.$refs.tree04.select(2);
        //this.$refs.tree04.select(5);
      },
      onClickDeselect() {
        this.$refs.tree04.deselect(2);
        this.$refs.tree04.deselect(5);
      },
      onClickPrint() {
        this.$refs.tree04.getNodeById('btn01').opened = false;
        console.log(this.$refs.tree04.getSelection());
      },
      onItemDoubleClick(node, model) {
        console.log(model.id);
      },
      onClickExpand() {
        this.$refs.tree04.getNodeById('btn01').opened = true;
      },
      onClickCollapse() {
        this.$refs.tree04.getNodeById('btn01').opened = false;
      },
      onClickReveal() {
        this.$refs.tree04.revealNode('item30');
      }
    }
  };
</script>
<style scoped>
.mybtn {
  width:100px;
  height: 30px;
  border: 1px solid blue;
}
</style>
